import { useEffect, useState } from "react";
import { DollarSign, Gauge, Network, Settings2, ShieldCheck } from "lucide-react";
import { api } from "@/lib/api";
import LuxSidebar from "./LuxSidebar";

/** Five sections, one console. Screens live in the console's own rail. */
const NAV = [
  { section: "Console", key: "overview",   to: "/platform/overview/today",    label: "Overview",   icon: Gauge,       tid: "admin-nav-overview" },
  { section: "Console", key: "network",    to: "/platform/network/properties", label: "Network",    icon: Network,     tid: "admin-nav-network" },
  { section: "Console", key: "commerce",   to: "/platform/commerce/services",  label: "Commerce",   icon: DollarSign,  tid: "admin-nav-commerce" },
  { section: "Console", key: "governance", to: "/platform/governance/audit",   label: "Governance", icon: ShieldCheck, tid: "admin-nav-governance" },
  { section: "Console", key: "system",     to: "/platform/system/flags",       label: "System",     icon: Settings2,   tid: "admin-nav-system" },
];

export default function AdminNav() {
  const [me, setMe] = useState(null);
  useEffect(() => {
    api.get("/platform/console/me").then((r) => setMe(r.data)).catch(() => setMe(null));
  }, []);

  const items = me ? NAV.filter((n) => me.sections.includes(n.key)) : NAV;
  const subtitle = me?.duty_labels?.length ? me.duty_labels.join(" · ") : "Administrator";

  return (
    <LuxSidebar
      items={items}
      subtitle={subtitle}
      footer={me?.read_only ? "Read-only access" : "Platform-level access"}
      testidPrefix="admin-nav"
      homePath="/platform/overview/today"
    />
  );
}
